import { render, staticRenderFns } from "./SDSView.vue?vue&type=template&id=0abb2220&scoped=true"
import script from "./SDSView.vue?vue&type=script&lang=js"
export * from "./SDSView.vue?vue&type=script&lang=js"
import style0 from "./SDSView.vue?vue&type=style&index=0&id=0abb2220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abb2220",
  null
  
)

export default component.exports